var keyUpTrackDelay = 500;

let trackKeyUp = false;
let timeSinceLastKeyUp = 0;

let searchFieldId = window.location.href.indexOf('/results') ? 'searchInputHero' : 'searchInputNav';

const catValue = () => {
    if (document.getElementById('cat')) {
        return document.getElementById('cat').selectedOptions[0].value;
    } else if ($('#productPurchaseRadio').length) {
        return $('input[name="radios"]:checked').val();
    }
    return 'productPurchase';
}

const searchTermValue = (encoded) => {
    console.log('searchFieldId is now...', searchFieldId);
    let searchTerm = document.getElementById(searchFieldId).value;

    // lower case search term to sanitize results in GA
    searchTerm = searchTerm.toLowerCase();
    return searchTerm;
}

const waitAndSetSearchQuery = (to) => {
    const timeout = to || 1000;

    console.log('Waiting for search...');
    setTimeout(function () {
        console.log('Updating links now...');

        const searchTerm = searchTermValue(true);

        console.log("searchTerm for links is...", searchTerm);
        const category = catValue();

        $("a.autocomplete-links").each(function () {
            const thisHref = $(this).attr("href");

            const thisId = $(this).attr("id");
            const linkTitle = $(this).find('p').eq(0).text();

            $(this).click(function () {
                mixPanelTrack('SearchClicked',{
                    searchTerm,
                    category,
                    searchField: searchFieldId,
                    linkTitle,
                    linkLocation: 'searchDrawer',
                    url: thisHref,
                });
            })
        });

        $("a.row").each(function () {
            const thisHref = $(this).attr("href");
            const thisId = $(this).attr("id");

            const linkTitle = $(this).find('li').eq(0).text();            

            $(this).click(function () {
                mixPanelTrack('SearchClicked',{
                    searchTerm,
                    category,
                    searchField: searchFieldId,
                    linkTitle,
                    linkLocation: 'resultsPage',
                    url: thisHref,
                });
            })
        });

    }, timeout);
};


const trackSearchTerm = () => {
    const searchTerm = searchTermValue();
    const category = catValue();
    if (searchTerm.length >= 2) {
        console.log('***** TRACK EVENT: search term is...', searchTerm);
        waitAndSetSearchQuery(500);

        mixPanelTrack('Search', {
            searchTerm,
            category,
            searchField: searchFieldId,
            url: window.location.href,
        })
    }
}

const resetTracking = () => {
    console.log('resetting tracking for search term input...');
    trackKeyUp = false;
    timeSinceLastKeyUp = 0;
}

const trackTimeSinceKeyUp = () => {
    if (trackKeyUp === true) {
        timeSinceLastKeyUp += keyUpTrackDelay;
        console.log('timeSinceLastKeyUp is now...', timeSinceLastKeyUp);
        if (timeSinceLastKeyUp >= 3000) {
            // reset tracking here
            resetTracking();
            trackSearchTerm();
        }
    } else {
        timeSinceLastKeyUp = 0;
    }

}

const searchKeyUp = () => {
    // after each key up, reset tracking
    resetTracking();
    // allow the tracking to start...
    trackKeyUp = true;
}

$(document).ready(function () {

    // we have radio buttons on results page...
    if ($('#productPurchaseRadio').length) {
        $('.custom-radio').on('click', function () {
            waitAndSetSearchQuery(500);
        });
    }

    if (document.getElementById('searchInputNav') || document.getElementById('searchInputHero')) {

        setInterval(() => {
            trackTimeSinceKeyUp();
        }, keyUpTrackDelay);
    }

    if (document.getElementById('searchInputNav')) {

        $('#searchInputNav').on("keyup", function () {
            searchKeyUp();
        });

        $("#searchInputNav").on("focus", function () {

            searchFieldId = 'searchInputNav';

            if (document.getElementById('searchInputHero')) {
                document.getElementById('searchInputHero').value = '';
            }
            console.log('SEARCH FOCUSED!!!!!');
        });

        // reset search as page loads to clear out old values.
        document.getElementById('searchInputNav').value = '';
    }

    if (document.getElementById('searchInputHero')) {

        // Update links on search results page as page loads
        waitAndSetSearchQuery(2200);

        $('#searchInputHero').on("keyup", function () {
            searchKeyUp();
        });

        $("#searchInputHero").on("focus", function () {

            searchFieldId = 'searchInputHero';

            if (document.getElementById('searchInputNav')) {
                document.getElementById('searchInputNav').value = '';
            }
            console.log('SEARCH FOCUSED!!!!!');
        });

        // Do not auto clear searchInputHero field as it loads from url values
    }
});
